import { _ as r } from "./_overArg.js";
var t = r, e = t(Object.getPrototypeOf, Object), a = e;
export {
  a as _
};
//# sourceMappingURL=_getPrototype.js.map
